import {ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, input} from '@angular/core'
import {InspirationItem, InspirationSection} from '../../../../core/content/types/inspiration-section.types'
import {ApplicationRoute} from '../../../../craft/utils/application.route'
import {ButtonModule} from '../../../../craft/button/button.module'
import {TeaserCardComponent} from '../../../../craft/cards/teaser-card/teaser-card.component'
import {TranslocoDirective} from '@ngneat/transloco'
import {TeaserCardTitleComponent} from '../../../../craft/cards/teaser-card/teaser-card-title/teaser-card-title.component'
import {ContentSectionComponent} from '../../../../craft/content-section/content-section.component'
import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'
import {pickProperty} from '../../../../core/graphql/graphql-utils'
import {parseArticlePreview} from '../../../../core/content/serde/article-page.serde'
import {LinkService} from '../../../../core/i18n/link.service'
import {ArticlePreview} from '../../../../core/content/types/article.types'
import {AsyncPipe} from '@angular/common'
import {RouterLink} from '@angular/router'
import {InspirationSection_SearchArticlesGql} from '../../../../../__generated__/types'
import {ChipComponent} from '../../../../craft/chip/chip.component'

@Component({
  selector: 'bgo-inspiration-section',
  templateUrl: './inspiration-section.component.html',
  styles: [':host { display: block }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContentSectionComponent,
    ButtonModule,
    TeaserCardComponent,
    TeaserCardTitleComponent,
    TranslocoDirective,
    AsyncPipe,
    ChipComponent,
    RouterLink,
  ],
  standalone: true,
})
export class InspirationSectionComponent {
  inspirationSection = input.required<InspirationSection>()

  $articles?: Observable<ArticlePreview[]>

  constructor(
    private searchArticles: InspirationSection_SearchArticlesGql,
    private linkService: LinkService,
    private cdr: ChangeDetectorRef,
  ) {
    effect(() => {
      const section = this.inspirationSection()
      const topics = section.topics?.map(t => t.slug)

      // Only load articles if no items are defined in the section
      if (!section.items.length) {
        this.$articles = this.searchArticles
          .fetch({
            // If topics is empty no filtering applied.
            topics,
            page: {
              limit: 4,
            },
          })
          .pipe(
            map(res => pickProperty(res.data, 'searchArticles')),
            map(articles => articles.items.map(article => parseArticlePreview(article, this.linkService))),
          )
        this.cdr.markForCheck()
      }
    })
  }

  identifier(item: InspirationItem): string | undefined {
    const cta = item.callToAction.value
    const path =
      cta instanceof ApplicationRoute ? cta.pathWithoutLocalizedRouteToken : (item.callToAction?.value.toString() ?? '')
    return `inspiration-article-${path.split('/').pop()}`
  }
}
